// 关于与帮助：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 关于和帮助
export const ui = Object.freeze({
  "pcAbout.about": "About XSOU",
  "pcAbout.contact": "Contact us",
  "pcAbout.join": "Careers",
  "pcAbout.privacy": "Privacy notice",
  "pcAbout.help": "Help center",
  "pcAbout.companyAlt": "XSOU Technology",
  "pcAbout.value1": "Philosophy",
  "pcAbout.value1Desc": "Customer-first, excellent service",
  "pcAbout.value2": "Spirit",
  "pcAbout.value2Desc": "Keep striving and creating",
  "pcAbout.value3": "Responsibility",
  "pcAbout.value3Desc": "Serve the industry and grow together",
  "pcAbout.value4": "Goal",
  "pcAbout.value4Desc": "Build trust and share value",
  "pcAbout.onlineMessage": "Send us a message",
  "pcAbout.name": "Name",
  "pcAbout.phone": "Phone",
  "pcAbout.email": "Email",
  "pcAbout.message": "Message",
  "pcAbout.enterName": "Enter your name",
  "pcAbout.enterPhone": "Enter your phone number",
  "pcAbout.enterEmail": "Enter your email address",
  "pcAbout.enterMessage": "Enter your message",
  "pcAbout.nameMax": "Name must be 50 characters or fewer",
  "pcAbout.phoneMax": "Phone number must be 30 characters or fewer",
  "pcAbout.invalidEmail": "Enter a valid email address",
  "pcAbout.emailMax": "Email must be 100 characters or fewer",
  "pcAbout.messageMax": "Message must be 1,000 characters or fewer",
  "pcAbout.submit": "Send message",
  "pcAbout.responsibilities": "Responsibilities",
  "pcAbout.requirements": "Requirements",
  "pcAbout.apply": "Apply now",
  "pcAbout.helpSearch": "Search help articles...",
  "pcAbout.hotSearch": "Popular searches:",
  "pcAbout.moreQuestions": "More questions?",
  "pcAbout.contactHelp": "Contact our support team for help",
  "pcAbout.contactSupport": "Contact support",
  "pcAbout.close": "Close",
  "pcAbout.pageTitle": "About us - XSOU",
  "pcAbout.fallbackTitle": "About us",
  "pcAbout.address": "Company address",
  "pcAbout.contactPhone": "Phone",
  "pcAbout.contactEmail": "Email",
  "pcAbout.hours": "Business hours",
  "pcAbout.weekdays": "Monday-Friday, 9:00-18:00",
  "pcAbout.addressValue":
    "704B, 4060 Qiaoxiang Road, Nanshan District, Shenzhen",
  "pcAbout.submitted": "Message sent",
  "pcAbout.submitFailed": "Couldn't send your message. Please try again later.",
  "pcAbout.content.about_xsou":
    "<p>Founded on August 24, 2017, Shenzhen XSOU Technology Co., Ltd. focuses on semiconductor memory chips. The company provides integrated supply-chain services, including financing, logistics, and information, with a mission to improve the business environment across the semiconductor chip supply chain.</p><p>XSOU brings together upstream and downstream resources in the storage industry. Through supply-chain and financial services, it aims to offer efficient, secure, cost-effective solutions and maintains relationships with manufacturers and brands including Samsung, Micron, SK hynix, Intel, and YMTC.</p>",
  "pcAbout.content.contact":
    "<p>Company address: 704B, 4060 Qiaoxiang Road, Nanshan District, Shenzhen</p><p>Phone: 400-966-2855</p><p>Email: fengke@xsou.com</p><p>Business hours: Monday-Friday, 9:00-18:00</p>",
  "pcAbout.content.join":
    "<p>XSOU is growing and welcomes talented, motivated people to join the team. We offer room to develop and career opportunities.</p>",
  "pcAbout.content.privacy":
    "<p>An approved English privacy notice is not available yet. The Chinese source text follows.</p>",
  "pcAbout.content.help":
    "<p>If you need help with signing in, orders, shipment tracking, after-sales service, or invoices, please contact support.</p>",
});

export const messages = Object.freeze({ ...ui });

// 英文帮助内容
export const helpArticles = Object.freeze({
  1: {
    title: "How do I register as an XSOU member?",
    summary: "Create an account in a few steps...",
    detail:
      "**Registration:**\n\n1. Select Register in the upper-right corner\n2. Enter your mobile number and request a verification code\n3. Set a password of 6-20 letters or numbers\n4. Read and accept the user agreement\n5. Select Register now\n\n**After registration:**\n- Browse supply listings\n- Post purchase requirements\n- Contact suppliers online\n- Access member pricing where available",
  },
  2: {
    title: "How do I reset my password?",
    summary: "Use your registered mobile number to reset it...",
    detail:
      "**Password reset:**\n\n1. Select Forgot password on the sign-in page\n2. Enter your registered mobile number\n3. Request and enter the SMS verification code\n4. Set a new password\n5. Confirm the change\n\n**Tips:**\n- The code is valid for 5 minutes\n- Use a combination of letters and numbers\n- Contact support if your mobile number has changed",
  },
  3: {
    title: "How do I post a supply listing?",
    summary: "Sign in and complete the listing form...",
    detail:
      "**Posting:**\n\n1. Sign in and open My account\n2. Select Post supply\n3. Enter product details such as part number, brand, and quantity\n4. Upload product images (up to five)\n5. Set pricing and transaction terms\n6. Submit the listing\n\n**Note:**\n- Keep information accurate\n- Use clear product images\n- Supply listings appear after review",
  },
  4: {
    title: "How do I cancel an order?",
    summary: "Cancellation depends on the order status...",
    detail:
      "**Before payment:**\n1. Open My orders\n2. Find the order\n3. Select Cancel order\n4. Choose a reason and confirm\n\n**After payment:**\n- Contact the seller to discuss cancellation\n- If the seller agrees, request a refund\n- Refunds are normally returned to the original payment method in 3-7 business days\n\n**Note:**\n- Check order details promptly\n- Shipped orders cannot be directly cancelled",
  },
  5: {
    title: "Which payment methods are supported?",
    summary: "Payment options may include Alipay and WeChat Pay...",
    detail:
      "**Payment methods:**\n\n1. Alipay for personal and business accounts\n2. WeChat Pay via balance or bank card\n3. Bank cards\n4. Corporate bank transfer for larger orders (contact support)\n\n**Security:**\n- Payment channels use encryption\n- Multiple verification methods are supported\n- Risk monitoring runs around the clock",
  },
  6: {
    title: "How do I track a shipment?",
    summary: "Check shipping details after an order is dispatched...",
    detail:
      "**Tracking:**\n\n1. Open My orders\n2. Find a shipped order\n3. Select View tracking\n4. Read the tracking updates\n\nTracking may include the carrier, tracking number, shipment history, and estimated delivery time. Tracking can take up to 24 hours to appear. Contact the seller or support if updates remain unavailable.",
  },
  7: {
    title: "What is the after-sales policy?",
    summary: "Check the options for returns and quality issues...",
    detail:
      "**Returns:**\n- Request an eligible return within 7 days of receipt\n- The item must be unused and suitable for resale\n\n**Quality issues:**\n- Photograph the issue and contact the seller or support\n- Available remedies depend on the case\n\n**Requesting service:**\n1. Open the order details\n2. Select After-sales service\n3. Choose a service type and enter the reason\n4. Upload supporting images\n5. Submit the request",
  },
  8: {
    title: "How do I request an invoice?",
    summary: "Request an invoice after your order is complete...",
    detail:
      "**Invoice request:**\n\n1. Open My orders after the order is complete\n2. Find the order and select Request invoice\n3. Choose an invoice type\n4. Enter the invoice details and submit\n\nOrdinary invoices are sent by email. VAT special invoices require full qualification details. Issuance may take 1-3 business days. Check the information carefully and contact support if an issued invoice needs changing.",
  },
});

// 英文帮助内容
export const helpCategories = Object.freeze({
  all: {
    name: "All questions",
    icon: "All",
  },
  register: {
    name: "Registration & login",
    icon: "Account",
  },
  order: {
    name: "Orders",
    icon: "Orders",
  },
  payment: {
    name: "Payments",
    icon: "Payment",
  },
  delivery: {
    name: "Shipping",
    icon: "Shipping",
  },
  aftersale: {
    name: "After-sales",
    icon: "Support",
  },
});

// 英文帮助内容
export const hotTags = Object.freeze([
  "Registration & login",
  "Order inquiries",
  "Shipment tracking",
  "After-sales service",
  "Invoices",
]);

// 英文帮助内容
export const jobs = Object.freeze({
  1: {
    title: "Frontend developer",
    type: "Full-time",
    location: "Shenzhen",
    duties: [
      "Develop and maintain the company's web products",
      "Help design and improve frontend architecture",
      "Work closely with product, design, and backend teams",
      "Improve user experience and page performance",
    ],
    requirements: [
      "Bachelor's degree or above in computer science or a related field",
      "At least 3 years of frontend development experience",
      "Proficiency with Vue.js, React, or similar frameworks",
      "Familiarity with HTML5, CSS3, and JavaScript",
      "Strong communication and teamwork skills",
    ],
  },
  2: {
    title: "Backend developer",
    type: "Full-time",
    location: "Shenzhen",
    duties: [
      "Design and develop backend systems",
      "Improve performance and reliability",
      "Review technical proposals and technology choices",
      "Write technical documentation and coding standards",
    ],
    requirements: [
      "Bachelor's degree or above in computer science or a related field",
      "At least 3 years of Java or Python development experience",
      "Familiarity with Spring Boot, Django, or similar frameworks",
      "Familiarity with MySQL, Redis, and other databases",
      "Distributed-system experience is a plus",
    ],
  },
  3: {
    title: "Product manager",
    type: "Full-time",
    location: "Shenzhen",
    duties: [
      "Plan products and analyze requirements",
      "Define roadmaps and release plans",
      "Coordinate development, design, and operations teams",
      "Track product data and user feedback",
    ],
    requirements: [
      "Bachelor's degree or above and at least 2 years of product management experience",
      "B2B platform experience is a plus",
      "Strong communication and coordination skills",
      "Proficiency with Axure, XMind, or similar tools",
    ],
  },
  4: {
    title: "Sales specialist",
    type: "Full-time",
    location: "Shenzhen",
    duties: [
      "Develop new customers and maintain existing relationships",
      "Meet sales goals and performance targets",
      "Gather market information and analyze competitors",
      "Attend trade shows and market events",
    ],
    requirements: [
      "Associate degree or above and at least 1 year of sales experience",
      "Electronic-components industry experience is a plus",
      "Strong communication skills and ability to work under pressure",
      "Willingness to travel",
    ],
  },
});
